// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"c42290c0","456":"918677fc","656":"0916d2ce","684":"ea93b97b","756":"0d6d8389","787":"3b083fb1"}[chunkId] + ".chunk.js";
};